import { Avatar } from "@mui/material";

export default function AvatarItem({children, openHeader, text, moduleActive, ...props}){
    return (
        <Avatar sx={{background: moduleActive == text  && !openHeader ? "white" : "transparent", color: moduleActive == text  && openHeader ? "#ffffff" : "#2c4992"}} {...props}>
            {children}
        </Avatar>
    )
}